export default __webpack_public_path__ + "4f2131b244f6248c9dec1469af2ad6ce.png";